
/* styles */
require("!!../../../node_modules/.store/extract-text-webpack-plugin@2.1.2/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-de3304f8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=styles&index=0!./SpectrumData.vue")

var Component = require("!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=script&index=0!./SpectrumData.vue"),
  /* template */
  require("!!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-de3304f8\"}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=template&index=0!./SpectrumData.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/charts/SpectrumData.vue
// module id = 1808
// module chunks = 1